var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-com',{attrs:{"nav":"4"}}),_c('header-home',{attrs:{"back":"#cdd0d2","color":"#000000"}}),_c('img',{staticClass:"explain-image",attrs:{"src":_vm.image,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }